// Copyright (c) 2020 Deere & Company

import MassUpdate from './components/mass-update-request-details';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.rga.search,
    ...state.rga.shared,
    links: state.app.links,
    rgaSelectedMassUpdate: state.rga.searchResults.rgaSelectedMassUpdate,
    security: state.user.security,
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {children, routeParams} = parentProps;

    const queryParams = parentProps.location.query;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        children,
        queryParams,
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(MassUpdate);



// WEBPACK FOOTER //
// ./src/rga/mass-update/mass-update-request.js